import { Component } from '@angular/core';

@Component({
    selector: 'app-ai-intraction',
    templateUrl: './ai-intraction.component.html',
    styleUrl: './ai-intraction.component.scss',
    standalone: false
})
export class AiIntractionComponent {

}
